<template>
  <div>
    <app-header></app-header>
    <h1 class="display-4 text-center">Please enter your e-mail address</h1>
    <p class="text-center">An e-mail with instructions to reset your password will be sent to this e-mail address.</p>
    <div class="container-fluid w-50 mt-5 bg-light">
      <div class="btn-danger text-center mb-3" v-show="error !== null">
        {{ error }}
      </div>
      <form @submit.prevent="pwreset">
        <div class="form-group">
          <label class="label">E-mail</label>
          <input type="text" class="input form-control" @input="changed()" v-model.trim="form.email" />
          <div v-if="$v.form.email.$dirty">
            <div class="text-danger" v-if="!$v.form.email.required">Email is required!</div>
            <div class="text-danger" v-if="!$v.form.email.email">Email is not valid!</div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-primary mb-3" type="submit">Send
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AppHeader from "./AppHeader";
import {required, email} from "vuelidate/lib/validators";
import store from '../../ClientApp/store';

export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      form: {
        email: '',
      },
      error: null
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
    }
  },
  methods: {
    changed (){
      this.$v.form.email.$touch();
      this.error = null;
    },
    pwreset() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return

      const payload = {
        Email: this.form.email,
      };
      this.$store
        .dispatch("pwreset", payload)
        .then(() => {
          this.error = null;
          this.form.email = "";
          this.$router.push("/login");
        })
        .catch(error => {
          this.error = error.data;
        });
      }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/intro/PasswordReset.vue